module.exports = __webpack_public_path__ + "static/media/SharpSans-Bold.7cc8cae4.woff";